<!-- 翻车机 多数据源接入 -->
<template>
  <dev>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </dev>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail} from "./api";
import {searchTimeConfig} from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '协议类型',
            prop: 'sourceType',
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=source_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择协议类型', trigger: 'change'}
            ],
          },
          {
            label: '设备编码',
            prop: 'deviceCode',
          },
          {
            label: '原始数据',
            prop: 'rawData',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: false,
            search: false, // 不参与查询
            rules: [
              {required: true, message: '请录入原始数据', trigger: 'blur'}
            ],
          },
          {
            label: '数据时间',
            prop: 'dataTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
          },
          {
            label: '解析后数据',
            prop: 'parsedData',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: false,
            search: false,
          },
          {
            label: "解析状态",
            prop: "parsedStatus",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=parsed_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择解析状态', trigger: 'change'}
            ],
            value: 0
          },
          {
            label: "指令类型",
            prop: "commandType",
            type: 'select',
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=command_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择指令类型', trigger: 'change'}
            ],
          },
          {
            label: '指令触发时间',
            prop: 'commandTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            value: this.getCurrentDateTimeString(),
            hide:true
          },
          {
            label: '最后更新时间',
            prop: 'lastUpdateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 180,
            value: this.getCurrentDateTimeString(),
          },
          {
            label: "连接状态",
            prop: "connectionStatus",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=connection_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择连接状态', trigger: 'change'}
            ],
            value: 1
          },
          {
            label: '备注',
            prop: 'remark',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
            rules: [
              {max: 500, message: '备注不能超过500个字符', trigger: 'blur'}
            ]
          },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择状态', trigger: 'change'}
            ],
            value: 1
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            search: false,
          },
        ]
      },
    }
  },
  methods:{
    /**
     * 获取当前日期时间的字符串（yyyy-MM-dd HH:mm:ss格式）
     */
    getCurrentDateTimeString() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    /**
     * 在打开对话框前设置默认值
     */
    beforeOpen(done, type) {
      if (type === 'add') {
        // 新增时设置默认值
        this.$nextTick(() => {
          this.form.commandTime = this.getCurrentDateTimeString();
          this.form.lastUpdateTime = this.getCurrentDateTimeString();
        });
      }
      done();
    },
  }
}
</script>
<style scoped lang="scss">
</style>
